import React, { useState } from 'react';
import ProgressSpinner from '@avtechsoftware/react-component-library/src/components/common/ProgressSpinner';
import PropTypes from 'prop-types';
import ConditionalRender
  from '@avtechsoftware/react-component-library/src/components/common/ConditionalRender/ConditionalRender';
import AlarmHistoryTableRowContent from '../AlarmHistoryTableRowContent/AlarmHistoryTableRowContent';
import envConfig from '../../../../../envConfig';
import RaaAuthenticatedRemoteService from '../../../../../utility/RaaAuthenticatedRemoteService';

function InfiniteScrollAlarmHistoryTable({ isMainHistoryPage, alertIdToFilterBy }) {
  const [events, setEvents] = useState([]);
  const [page, setPage] = useState(0);
  const [loading, setLoading] = useState(true);
  const [hasMore, setHasMore] = useState(false);

  const queryUrl = isMainHistoryPage
    ? `${envConfig.apiUrl}/api/v2/alert-event/history/subscription/transport-counts`
    : `${envConfig.apiUrl}/api/v2/alert-event/history/alert/transport-counts/alert?id=${alertIdToFilterBy}&`;

  React.useEffect(() => {
    setLoading(true);
    const fetchEvents = async () => {
      try {
        const response = await RaaAuthenticatedRemoteService.globalInstance()
          .get(`${queryUrl}?pageNo=${page}&pageSize=${20}`);
        setEvents(
          (prevEvents) => [...new Set([...prevEvents, ...response.alertEventList])],
        );
        setHasMore(response.alertEventList.length > 0);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log('error fetching alarm history log');
      }

      setLoading(false);
    };
    fetchEvents();
  }, [page]);

  const observer = React.useRef();
  // Andy said to ignore
  /* istanbul ignore next */
  const lastEventRef = React.useCallback(
    (node) => {
      if (loading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          setPage((prevPage) => prevPage + 1);
        }
      });
      if (node) observer.current.observe(node);
    }, [loading, hasMore],
  );

  return (
    <>
      {isMainHistoryPage && <h2>Alarm History</h2>}
      <div className="table-responsive">
        <table className="table table-condensed table-striped small">
          <thead>
            <tr>
              <th>Began - Ended</th>
              <th>Duration</th>
              <th>Source</th>
              <th>Trigger</th>
              <th>Clear</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {events.map((alert, index) => {
              if (events.length === index + 1) {
                return (
                  <tr
                    key={index}
                    ref={lastEventRef}
                  >
                    <AlarmHistoryTableRowContent alert={alert} />
                  </tr>
                );
              }
              return (
                <tr key={index}>
                  <AlarmHistoryTableRowContent alert={alert} />
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      <ConditionalRender show={loading}>
        <div className="row d-flex justify-content-center my-5">
          <div>
            <ProgressSpinner progressText="Searching..." />
          </div>
        </div>
      </ConditionalRender>

      <ConditionalRender show={(!loading && events.length === 0)}>
        <div className="row d-flex justify-content-center my-5">
          <div>
            <span className="alert alert-warning">No History</span>
          </div>
        </div>
      </ConditionalRender>

    </>
  );
}

InfiniteScrollAlarmHistoryTable.defaultProps = {
  isMainHistoryPage: true,
  alertIdToFilterBy: '',
};

InfiniteScrollAlarmHistoryTable.propTypes = {
  isMainHistoryPage: PropTypes.bool,
  alertIdToFilterBy: PropTypes.string,
};

export default InfiniteScrollAlarmHistoryTable;
